import { Route } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';

/**
 * Pobiera ustawienie z kolumnami
 *
 * @export
 * @param {Route} route
 * @returns {Promise<void>}
 */
export function getColumnsSetting(route: Route): Promise<void> {
  if (route.query.statusId) {
    return store
      .dispatch('setting/findPublic', {
        code: PublicSettings.COLUMNS,
        entityType: EntityType.STATUS,
        entityId: route.query.statusId.toString()
      })
      .then(setting => setting || getProcedureColumnsSetting(route));
  }
  return getProcedureColumnsSetting(route);
}

/**
 * Pobiera ustawienie z kolumnami procedury
 *
 * @param {Route} route
 * @returns {Promise<void>}
 */
function getProcedureColumnsSetting(route: Route): Promise<void> {
  if (route.params.procedureId) {
    return store
      .dispatch('setting/findPublic', {
        code: PublicSettings.COLUMNS,
        entityType: EntityType.PROCEDURE,
        entityId: route.params.procedureId.toString()
      })
      .then(setting => setting || getDefaultColumnsSetting());
  }
  return getDefaultColumnsSetting();
}

/**
 * Pobiera ustawienie z domyślnymi kolumnami
 *
 * @returns {Promise<void>}
 */
function getDefaultColumnsSetting(): Promise<void> {
  return store.dispatch('setting/findPublic', { code: PublicSettings.COLUMNS });
}
